export default "__VITE_ASSET__BXi0nDgy__"